import * as LottiePlayer from "@lottiefiles/lottie-player";

const Lottie = () => {
  if ($(".block-approach").length) {
    const player = document.querySelector("#approach-lottie");
    player.load(
      "https://assets7.lottiefiles.com/private_files/lf30_q22bw4ml.json" 
    );
    player.stop();
    var observer = new IntersectionObserver(
      (entries) => {
        // isIntersecting is true when element and viewport are overlapping
        // isIntersecting is false when element and viewport don't overlap
        if (entries[0].isIntersecting === true)
          console.log("Element has just become visible in screen");
        player.stop();
        player.play();
      },
      { threshold: [0], rootMargin: "-100px" }
    );

    observer.observe(document.querySelector(".block-approach"));
  }
};

export default Lottie;
